// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_HOWrt {
  display: grid;
  row-gap: var( --size-padSmall, 8px );
  column-gap: var( --size-padSmall, 8px );
  align-items: center;
  justify-content: stretch;
  grid-template-areas: "prim"; 
  grid-template-columns: 1fr;
}

.header_HOWrt.hasIcon_ICl7Q.hasControls_vsa7o {
  grid-template-areas: "icon prim opt"; 
  grid-template-columns: auto 1fr auto;
}

.header_HOWrt.hasIcon_ICl7Q {
  grid-template-areas: "icon prim"; 
  grid-template-columns: auto 1fr;
}

.header_HOWrt.hasControls_vsa7o {
  grid-template-areas: "prim opt"; 
  grid-template-columns: 1fr auto;
}


.icon_pGr2Y {
  grid-area: icon;
}

.controls_Hl4ae { 
  grid-area: opt;
  white-space: nowrap;
}

.primary_YQ6cR { 
  grid-area: prim;
  white-space: nowrap;
}

.header_HOWrt.hasControls_vsa7o > .primary_YQ6cR {
  padding-right: var( --size-padMedium, 16px )
}

.secondary_YqTO9 { 
  grid-area: sec;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/detail/shared/DetailHeader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oCAAoC;EACpC,uCAAuC;EACvC,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;AACjC;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".header {\n  display: grid;\n  row-gap: var( --size-padSmall, 8px );\n  column-gap: var( --size-padSmall, 8px );\n  align-items: center;\n  justify-content: stretch;\n  grid-template-areas: \"prim\"; \n  grid-template-columns: 1fr;\n}\n\n.header.hasIcon.hasControls {\n  grid-template-areas: \"icon prim opt\"; \n  grid-template-columns: auto 1fr auto;\n}\n\n.header.hasIcon {\n  grid-template-areas: \"icon prim\"; \n  grid-template-columns: auto 1fr;\n}\n\n.header.hasControls {\n  grid-template-areas: \"prim opt\"; \n  grid-template-columns: 1fr auto;\n}\n\n\n.icon {\n  grid-area: icon;\n}\n\n.controls { \n  grid-area: opt;\n  white-space: nowrap;\n}\n\n.primary { \n  grid-area: prim;\n  white-space: nowrap;\n}\n\n.header.hasControls > .primary {\n  padding-right: var( --size-padMedium, 16px )\n}\n\n.secondary { \n  grid-area: sec;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_HOWrt`,
	"hasIcon": `hasIcon_ICl7Q`,
	"hasControls": `hasControls_vsa7o`,
	"icon": `icon_pGr2Y`,
	"controls": `controls_Hl4ae`,
	"primary": `primary_YQ6cR`,
	"secondary": `secondary_YqTO9`
};
export default ___CSS_LOADER_EXPORT___;
